/* SKY collection grid column switcher: 2/3/4/6 desktop, 1/2 mobile.
   Persists in localStorage (survives visits; URL params would pollute share
   links and split the page cache, so none is used). On switch it rewrites
   every card image's `sizes` to the real rendered width so srcset picks the
   right file - the static sizes attr assumed a fixed column count. */
(() => {
  if (window.skyColsInit) return; window.skyColsInit = true;
  const DESK = [2, 3, 4, 6], MOB = [1, 2];
  const get = (k, d) => { try { return localStorage.getItem(k) || d; } catch (e) { return d; } };
  const set = (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} };
  const applyAttrs = () => {
    document.documentElement.dataset.skyCols = get('sky_cols', '4');
    document.documentElement.dataset.skyMcols = get('sky_mcols', '2');
  };
  applyAttrs();
  const glyph = (n) => {
    const cols = n <= 3 ? n : (n === 4 ? 4 : 6);
    let cells = '';
    const w = 24 / cols - 2;
    for (let r = 0; r < 2; r++)
      for (let c = 0; c < cols; c++)
        cells += `<rect x="${c * (w + 2)}" y="${r * 8}" width="${w}" height="6" fill="currentColor"/>`;
    return `<svg width="24" height="14" viewBox="0 0 24 14" aria-hidden="true">${cells}</svg>`;
  };
  const rewriteSizes = () => requestAnimationFrame(() => {
    document.querySelectorAll('.product-grid img[srcset]').forEach((img) => {
      const w = Math.round(img.getBoundingClientRect().width) || 300;
      img.setAttribute('sizes', w + 'px');
    });
  });
  const init = () => {
    const grid = document.querySelector('.product-grid');
    if (!grid) return;
    const bar = document.querySelector('.facets__form') || document.querySelector('.sorting-filter')?.parentElement;
    if (!bar) return;
    const wrap = document.createElement('div');
    wrap.className = 'sky-cols';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Products per row');
    const mkbtn = (n, key, attr) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'sky-cols__btn sky-cols__btn--' + (key === 'sky_cols' ? 'desk' : 'mob');
      b.innerHTML = glyph(n);
      b.setAttribute('aria-label', n + ' per row');
      const sync = () => b.setAttribute('aria-pressed', document.documentElement.dataset[attr] === String(n));
      sync();
      b.addEventListener('click', () => {
        set(key, String(n)); applyAttrs();
        wrap.querySelectorAll('button').forEach((x) => x.dispatchEvent(new Event('sky-sync')));
        rewriteSizes();
      });
      b.addEventListener('sky-sync', sync);
      return b;
    };
    DESK.forEach((n) => wrap.appendChild(mkbtn(n, 'sky_cols', 'skyCols')));
    MOB.forEach((n) => wrap.appendChild(mkbtn(n, 'sky_mcols', 'skyMcols')));
    bar.appendChild(wrap);
    rewriteSizes();
    const rl = document.querySelector('results-list');
    if (rl) new MutationObserver(rewriteSizes).observe(rl, { childList: true, subtree: true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
